import React, { FC } from 'react';
import {
    SkeletonBlock,
    SkeletonFooterBar,
    SkeletonPageHeader,
    SkeletonPageShell,
    SkeletonRow,
    SkeletonStack,
    SkeletonSurface
} from 'src/components/widgets/skeleton';

export const DesignWithAiPageSkeleton: FC = () => (
    <SkeletonPageShell aria-hidden='true' $padding='20px 0 92px'>
        <SkeletonPageHeader>
            <SkeletonStack $gap='8px' $flex='1'>
                <SkeletonRow $gap='10px'>
                    <SkeletonBlock $width='230px' $height='28px' />
                    <SkeletonBlock $width='82px' $height='22px' $radius='999px' />
                    <SkeletonBlock $width='64px' $height='22px' $radius='999px' />
                </SkeletonRow>
                <SkeletonBlock $width='min(680px, 100%)' $height='13px' />
                <SkeletonBlock $width='90px' $height='13px' />
            </SkeletonStack>
        </SkeletonPageHeader>
        <SkeletonStack $gap='20px'>
            <SkeletonSurface $padding='24px'>
                <SkeletonStack $gap='22px'>
                    <SkeletonRow $gap='12px'>
                        <SkeletonBlock $width='42px' $height='22px' $radius='999px' />
                        <SkeletonBlock $width='min(280px, 70%)' $height='16px' />
                    </SkeletonRow>
                    <SkeletonStack $gap='14px'>
                        <SkeletonBlock $width='130px' $height='13px' />
                        <SkeletonBlock $width='min(520px, 100%)' $height='38px' $radius='6px' />
                    </SkeletonStack>
                    <SkeletonSurface $padding='18px'>
                        <SkeletonStack $gap='12px'>
                            <SkeletonBlock $width='180px' $height='16px' />
                            <SkeletonBlock $width='min(620px, 100%)' $height='12px' />
                            <SkeletonBlock $width='min(700px, 100%)' $height='120px' $radius='6px' />
                            <SkeletonBlock $width='70px' $height='12px' $margin='0 0 0 auto' />
                        </SkeletonStack>
                    </SkeletonSurface>
                    <SkeletonBlock $height='58px' $radius='6px' />
                </SkeletonStack>
            </SkeletonSurface>
            <SkeletonSurface $padding='22px'>
                <SkeletonStack $gap='16px'>
                    <SkeletonBlock $width='180px' $height='20px' />
                    <SkeletonRow $gap='14px'>
                        <SkeletonBlock $width='18px' $height='18px' $radius='4px' />
                        <SkeletonBlock $width='260px' $height='14px' />
                    </SkeletonRow>
                    <SkeletonRow $gap='14px'>
                        <SkeletonBlock $width='18px' $height='18px' $radius='4px' />
                        <SkeletonBlock $width='220px' $height='14px' />
                    </SkeletonRow>
                </SkeletonStack>
            </SkeletonSurface>
            <SkeletonBlock $height='58px' $radius='6px' />
        </SkeletonStack>
        <SkeletonFooterBar>
            <SkeletonBlock $width='88px' $height='36px' $radius='6px' />
        </SkeletonFooterBar>
    </SkeletonPageShell>
);
